
(function () {
  if (customElements.get('et-card-slider')) {
    return;
  }

  // Swiper may arrive late (deferred/injected). One shared readiness gate for
  // every card — a collection page mounts 24+ cards at once, and a 100ms
  // interval per card meant 24+ concurrent timers doing the same check.
  let swiperReady = null;
  const whenSwiperReady = () => {
    if (typeof Swiper !== 'undefined') {
      return Promise.resolve();
    }
    if (!swiperReady) {
      swiperReady = new Promise((resolve) => {
        let attempts = 0;
        const poll = setInterval(() => {
          attempts += 1;
          if (typeof Swiper !== 'undefined' || attempts >= 100) {
            clearInterval(poll);
            resolve(); // on give-up init() re-checks and no-ops
          }
        }, 100);
      });
    }
    return swiperReady;
  };

  class ETCardSlider extends HTMLElement {
    connectedCallback() {
      if (this.swiper) {
        return;
      }
      whenSwiperReady().then(() => this.init());
    }

    disconnectedCallback() {
      if (this.swiper) {
        this.swiper.destroy(true, false);
        this.swiper = null;
      }
    }

    init() {
      if (this.swiper || !this.isConnected || typeof Swiper === 'undefined') {
        return;
      }
      this.swiper = new Swiper(this, {
        rewind: true,
        watchOverflow: true,
        navigation: {
          prevEl: this.querySelector('.card-prev'),
          nextEl: this.querySelector('.card-next')
        },
        pagination: {
          el: this.querySelector('.swiper-pagination'),
          clickable: true
        }
      });
    }
  }

  customElements.define('et-card-slider', ETCardSlider);


  customElements.whenDefined('pagination-theme').then(() => {
    const Pagination = customElements.get('pagination-theme');
    const addUrlParam = Pagination.prototype.addUrlParam;
    Pagination.prototype.addUrlParam = function (search, key) {
      let params = addUrlParam.call(this, search, key);
      const grid = document.querySelector('[data-et-template-suffix]');
      const suffix = grid && grid.getAttribute('data-et-template-suffix');
      if (suffix && !/[?&]view=/.test(params)) {
        params += '&view=' + encodeURIComponent(suffix);
      }
      return params;
    };
  });
})();
